export default __webpack_public_path__ + "static/media/fair_clouds_4k.67a542cb.png";